<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-product-ipr-list" class="ag-grid-container">
    <statistics-cards :data="statisticalData"/>

    <div class="vx-card">
      <div v-show="showGridOne" class="grid-one">
        <grid-panel
            height="md"
            :column-defs="columnDefs"
            :url="() => productList"
            :auto-size="true"
            @rowClicked="view"
            show-deleted-toggle
            class="products-grid"
            @update:deleted="getProducts"
            title="Products"
            ref="productGrid"
        >
          <template v-slot:right>
            <button-toggle
                class="ml-0 mr-4"
                v-model="toggleValue"
                :options="toggle"
            />
          </template>

          <vs-dropdown-item v-if="componentAccess.canCreate.access">
            <span
                class="flex items-center"
                @click="$router.push({ name: `${ProductCompanyType}.products-ipr.create` })"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
              <span>Create Product</span>
            </span>
          </vs-dropdown-item>

        </grid-panel>
      </div>

      <div v-show="!showGridOne" class="grid-two">

        <grid-panel
            :column-defs="sectionColumnDefs"
            :url="() => productListBySection"
            @rowClicked="view"
            class="products-grid by-section"
            :auto-group-column-def="autoGroupColumnDef"
            :gridOptions="productsBySectionGridOptions"
            title="Products"
            ref="productGridBySection"
        >
          <template v-slot:right>
            <button-toggle
                class="ml-0 mr-4"
                v-model="toggleValue"
                :options="toggle"
            />
          </template>

          <vs-dropdown-item v-if="componentAccess.canCreate.access">
            <span
                class="flex items-center"
                @click="$router.push({ name: `${ProductCompanyType}.products-ipr.create` })"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
              <span>Create Product</span>
            </span>
          </vs-dropdown-item>
        </grid-panel>
      </div>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import ButtonToggle from "../../components/extra-components/toggle/ButtonToggle";
import StatisticsCards from '@/components/statistics-cards/StatisticsCards.vue'

export default {
  components: {
    TGrid,
    GridPanel,
    YesNoToggle,
    ButtonToggle,
    StatisticsCards
  },
  mixins: [CellMatchingMixin, CanAccessMixin, IprProductCompanyTypeMixin],
  data () {
    return {
      componentAccess: {
        canCreate: {
          route: `${this.ProductCompanyType}.products-ipr.create`,
          access: false,
        },
      },
      toggle: [
        {
          text: 'None',
          value: 0,
        },
        {
          text: 'By Section',
          value: 1,
        }
      ],
      toggleValue: 0,
      productList: [],
      productListBySection: [],
      searchQuery: '',
      showDeleted: false,
      productsBySectionGridOptions: {
        // groupUseEntireRow: true,
        // groupMultiAutoColumn: true,
        // groupRowRendererParams: {
        //   suppressCount: false
        // },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Product Code',
          field: 'ProductCode',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Product Description',
          field: 'ProductDescription',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Insurance Type',
          field: 'Type',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Wording',
          field: 'WordingCode',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Standard Clause',
          field: 'StandardClause',
          filter: 'agTextColumnFilter',
          width: 350,
        },
      ],
      sectionColumnDefs: [
        {
          headerName: 'Facility Reference',
          field: 'Facility_PK',
          width: 200,
          filter: 'agTextColumnFilter',
          rowGroup: true,
          valueGetter: (data) => {
            if (data.data) {
              return data.data.FacilityReference;
            }

            return data.value;
          },
        },
        {
          headerName: 'Section',
          field: 'Section',
          width: 180,
          filter: 'agTextColumnFilter',
          rowGroup: true,
        },
        {
          headerName: 'Product Code',
          field: 'ProductCode',
          filter: 'agTextColumnFilter',
          minWidth: 180,
        },
        {
          headerName: 'Product Description',
          field: 'ProductDescription',
          filter: 'agTextColumnFilter',
          minWidth: 350,
        },
        {
          headerName: 'Wording',
          field: 'WordingCode',
          filter: 'agTextColumnFilter',
          minWidth: 180,
        },
        {
          headerName: 'Insurance Type',
          field: 'Type',
          filter: 'agTextColumnFilter',
          minWidth: 250,
        },
      ],
      autoGroupColumnDef: {
        minWidth: 200,
      },
      statisticalData: {
        products: {
          icon: 'file',
          label: 'Total Products',
          value: 0,
          tooltipText: 'Total Products',
        },
      },
    }
  },
  computed: {
    showGridOne() {
      return this.toggleValue === 0;
    },
  },
  watch: {
    productList: {
      async handler(productList) {
        const { data } = await productList;
        let count = 0;

        if (data) {
          count = data.data.length;
        }

        this.statisticalData.products.value = count;
      },
      deep: true,
      immediate: true,
    },
    ProductCompanyType_FK() {
      this.fetchData();
      this.$refs.productGrid.list();
      this.$refs.productGridBySection.list();
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.getProducts();
      this.getProductsBySection();
    },
    getProducts(isDeleted = 0) {
      const params = { IsDeleted: isDeleted };
      this.productList = this.$api[this.companyTypeApiModel('productsIpr')].list({ params });

      return this.productList;
    },
    getProductsBySection(isDeleted = 0) {
      const params = { IsDeleted: isDeleted };
      this.productListBySection = this.$api[this.companyTypeApiModel('productsIpr')].listBySection(params);

      return this.productListBySection;
    },
    view({data}) {
      if (!data) {
        return;
      }

      this.$router.push({ name: `${this.ProductCompanyType}.products-ipr.view`, params: { id: data.id }}).catch(() => {});
    }
  },

}

</script>

<style lang="scss">
</style>
